import { useCallback, useMemo, useState } from 'react';
import { HostAppContext } from './hostAppContext/context/HostAppContext';
import { usageTracker } from './utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const GlobalContext = ({
  children,
  hostAppName,
  hostAppPathName,
  variant,
  customCopilotId,
  isPreviewMode = false
}) => {
  const [isAppSetupComplete, setIsAppSetupComplete] = useState(false);
  const [isCopilotExpanded, setIsCopilotExpanded] = useState(false);
  const [isGlobalSearchOpen, setIsGlobalSearchOpen] = useState(false);
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const setIsCopilotExpandedWithTracking = useCallback((isExpanded, options) => {
    if (isCopilotExpanded !== isExpanded) {
      setIsCopilotExpanded(isExpanded);
      if (!options.skipTracking) {
        usageTracker.track('chatspotCoreInteraction', {
          action: isExpanded ? 'copilot-expanded' : 'copilot-collapsed',
          source: options.source
        });
      }
    }
  }, [isCopilotExpanded, setIsCopilotExpanded]);
  const hostAppContextValue = useMemo(() => {
    return {
      isAppSetupComplete,
      isCopilotExpanded,
      isGlobalSearchOpen,
      isUserScrolling,
      setIsAppSetupComplete,
      setIsCopilotExpanded: setIsCopilotExpandedWithTracking,
      setIsGlobalSearchOpen,
      setIsUserScrolling,
      sourceHostApp: hostAppName,
      sourceHostAppPathname: hostAppPathName,
      variant,
      customCopilotId,
      isPreviewMode
    };
  }, [isCopilotExpanded, isGlobalSearchOpen, hostAppName, hostAppPathName, isAppSetupComplete, setIsCopilotExpandedWithTracking, variant, isUserScrolling, customCopilotId, isPreviewMode]);
  return /*#__PURE__*/_jsx(HostAppContext.Provider, {
    value: hostAppContextValue,
    children: children
  });
};
export default GlobalContext;